import TableCell from "@tiptap/extension-table-cell";
import TableCellNodeView from "./TableCell.svelte";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { mergeAttributes } from "@tiptap/core";

const CustomTableCell = TableCell.extend({
  // extended attributes and renderHTML as workaround for tiptap bug where column widths don't persist when editor isn't isEditable: https://github.com/ueberdosis/tiptap/issues/2041
  addAttributes() {
    return {
      colspan: {
        default: 1,
      },
      rowspan: {
        default: 1,
      },
      colwidth: {
        default: [180],
        parseHTML: (element) => {
          const colwidth = element.getAttribute("colwidth");
          const value = colwidth ? colwidth.split(",").map((w) => parseInt(w, 10)) : null;
          return value;
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    let totalWidth = 0;
    let fixedWidth = true;

    if (HTMLAttributes.colwidth) {
      HTMLAttributes.colwidth.forEach((col: number) => {
        if (!col) {
          fixedWidth = false;
        } else {
          totalWidth += col;
        }
      });
    } else {
      fixedWidth = false;
    }

    if (fixedWidth && totalWidth > 0) {
      HTMLAttributes.style = `width: ${totalWidth}px;`;
    } else if (totalWidth && totalWidth > 0) {
      HTMLAttributes.style = `min-width: ${totalWidth}px`;
    } else {
      HTMLAttributes.style = null;
    }

    return ["td", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addNodeView() {
    return SvelteNodeViewRenderer(TableCellNodeView, { as: "td" });
  },
});

export default CustomTableCell;
